import React, { useState } from 'react';

import cx from 'classnames';

import { NewsletterForm } from '../forms/newsletter-form/NewsletterForm';
import { formData } from './payload';

import backgroundImage from '@images/newsletterBanner/newsletter-background-img.svg';

import * as styles from './newsletter-banner.module.scss';
import './hubspot-embedded-form.scss';

const NewsletterBanner = ({ subtitleLess }) => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const { mainTitle, description, thankYouTitle, thankYouNote } = formData;

  function runSetFormSubmitted() {
    setFormSubmitted(true);
  }

  return (
    <div
      id="subscribeNewsletterForm"
      className={subtitleLess ? cx(styles.container, styles.shorter) : styles.container}
    >
      {!formSubmitted ? (
        <>
          <h3 className={subtitleLess ? cx(styles.title, styles.withoutSubtitle) : styles.title}>{mainTitle}</h3>
          {!subtitleLess && <p className={styles.subtitle}>{description}</p>}
          <NewsletterForm runSetFormSubmitted={runSetFormSubmitted} formId="c923975c-c93f-457d-8c28-402d4a54aad5" />
        </>
      ) : (
        <>
          <h3 className={styles.title}>{thankYouTitle}</h3>
          <p className={styles.thanksSubtitle}>{thankYouNote}</p>
          <img loading="lazy" src={backgroundImage} alt="Bottom image" />
        </>
      )}
    </div>
  );
};

export default NewsletterBanner;
